import { clean } from '../pages/Fosun/pages/Login/toLogin';
import { navTo } from './navigation';
import { gotoLogin } from './gotoLogin';
import { isInFosun } from './development';

/** 登录态过期登出后跳转登录 */
export const logout = () => {
  clean();
  if (isInFosun()) {
    return navTo({
      url: '/h5_fe_shop/html/fosun/home/'
    });
  }

  gotoLogin();
};
